import React from "react";
import { Tabs, Modal, Empty, Spin, Table, Radio, Icon, Pagination } from "antd";
import moment from "moment/moment";
import DateRange from "@/DateRange";
import { promotionActions } from "$STORE/promotionSlice";
import { getRebateListAction } from "$STORE/thunk/promotionThunk";
import { connect } from "react-redux";
import { getPromotionCategories } from "$ACTIONS/promotionRequest";
import { numberformatter } from "$ACTIONS/util";
const { TabPane } = Tabs;

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rebateDetailTitle: [
                {
                    title: "ยอดหมุนเวียน", //流水
                    dataIndex: "turnover",
                    key: "turnover",
                },
                {
                    title: "เงินคืน", //返水
                    dataIndex: "rebate",
                    key: "rebate",
                },
                {
                    title: "รหัส", //编号
                    dataIndex: "rebateId",
                    key: "rebateId",
                },
                {
                    title: "วันที่", //日期
                    dataIndex: "date",
                    key: "date",
                },
            ],
            isSelfDefined: false, //是否為自訂義區間
            visible: false,
            Categories: [],
            Promotions: [],
            filterdata: this.props.rebateData,
            activeproms: "",
            PromotionsContent: [],
            openModalDetail: [], //打開modal的資料
            rulestatus: false,
            OpenForm: false,
            ActivePromotionsContent: "",
            remark: "",
            formspinning: false,
            Tabkey: "0",
            realyName: "", // 为了触发完善姓名后的value更新
            newsList: {},
            isLogin: false,
            dateRadio: "1",
            //-----------New
            RebateList: [], //拿取反水的icon
            ReabteIcon: {
                Sport: "",
                ESports: "",
                Casino: "",
                P2P: "",
                Slot: "",
                Lottery: "",
            }, //專存icon
            RebateDataList: [], //返水的全部資料
            RebateHistoryList: [], //返水歷史紀錄
            SelectedCategory: "All",
            RebateTotal: 0,
            ApplyDate: "",
            columns: [
                {
                    title: "ยอดหมุนเวียน", //流水
                    dataIndex: "bet",
                },
                {
                    title: "เงินคืน", //返水
                    dataIndex: "amount",
                },
                {
                    title: "รหัส", //編號
                    dataIndex: "id",
                },
                {
                    title: "วันที่", //日期
                    dataIndex: "date",
                },
            ],
            definedDate: {
                startTime: moment().format("YYYY-MM-DD"),
                endTime: moment().format("YYYY-MM-DD"),
            },
            visibleDateRange: false, // 自定义时间范围
            pageIndex: 1, //返水頁碼
            isLoading: false, //是否換日期區間Loading中
            pageSize: 10,
        };

        this.setTlcGameIframeHeightCount = 0;
        // this.timer = null; // 输入金额请求间隔时间段
        this.finishRealyNameNextStepInfo = {}; // 完善真实姓名下一步所需（当前优惠详情信息）
        this.promotionIsLogin = false; // 为了避免静态登陆之后重复调用获取优惠的API，本地记录获取状态
        this.changeRadio = this.changeRadio.bind(this); // 改变单选框
        this.setFilterData = this.setFilterData.bind(this); //設定filterData資料
    }

    componentDidMount() {
        /* 获取优惠分类 */
        this.getCategories();

        if (localStorage.getItem("access_token")) {
            this.props.setRebateData(
                this.state.definedDate.startTime,
                this.state.definedDate.endTime,
                this.state.SelectedCategory,
                () => {
                    this.setState({ isLoading: false });
                }
            );
            return;
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.topTabIndex !== this.props.topTabIndex &&
            this.props.topTabIndex === "3"
        ) {
            this.setState({ dateRadio: "1", isSelfDefined: false });
        }

        if (prevProps.rebateData !== this.props.rebateData) {
            if (this.state.SelectedCategory === "All") {
                this.setState({ filterdata: this.props.rebateData });
            } else {
                this.setState({
                    filterdata: this.props.rebateData.filter(
                        (item) =>
                            item.promotionCategory ===
                            this.state.SelectedCategory
                    ),
                });
            }
        }

        if (prevState.SelectedCategory !== this.state.SelectedCategory) {
            const filterdata = this.props.rebateData.filter(
                (item) => item.promotionCategory === this.state.SelectedCategory
            );
            console.log("filterdata", filterdata);

            let total = 0;
            if (this.state.SelectedCategory === "All") {
                total = this.props.rebateData.reduce((acc, item) => {
                    acc += item.totalGivenAmount;
                    return acc;
                }, 0);
            } else {
                total = filterdata.reduce((acc, item) => {
                    acc += item.totalGivenAmount;
                    return acc;
                }, 0);
            }

            this.props.setRebateFilterTotalAmount(total);
            this.setState({
                filterdata:
                    this.state.SelectedCategory === "All"
                        ? this.props.rebateData
                        : filterdata,
            });
        }
    }
    componentWillUnmount() {
        // clearTimeout(this.timer);
    }

    /**
     * @description: 获取优惠分类
     * @return {*}
     */
    async getCategories() {
        /* 获取全优惠分类 */
        const appliedHistories = await getPromotionCategories();
        if (appliedHistories && appliedHistories.length > 0) {
            const rebateCategory = appliedHistories.filter(
                (item) => item.parentName === "Rebate"
            );
            const all = {
                PromoCatID: "",
                PromoCatCode: "All",
                resourcesName: "ทั้งหมด", //全部
                promoCatImageUrl: "/th/img/promotions/icon/icon-all.png",
                parentId: "",
                parentName: "Rebate",
            };

            this.setState({
                RebateList: [all, ...rebateCategory],
                PromotionCategories: rebateCategory,
            });
        }
    }

    setFilterData(data) {
        this.setState({ filterdata: data });
    }

    setIframeHeight(iframe) {
        if (iframe) {
            var iframeWin =
                iframe.contentWindow || iframe.contentDocument.parentWindow;
            if (iframeWin.document.body) {
                // 内置padding手动设15像素，所以此处额外增加32像素高度
                iframe.style.height =
                    (iframeWin.document.documentElement.offsetHeight ||
                        iframeWin.document.body.offsetHeight) +
                    32 +
                    "px";
            }
        }
    }

    callback(key) {
        console.log(key);
        // if (key === null || key === "0") {
        //     return this.setState({
        //         filterdata: this.state.RebateDataList,
        //         Tabkey: "0",
        //     });
        // }

        const selectedCategory = this.state.RebateList[key].PromoCatCode;
        console.log("selectedCategory", selectedCategory);

        this.setState({
            Tabkey: key.toString(),
            SelectedCategory: selectedCategory,
            pageIndex: 1,
        });
        Pushgtagdata(
            "Promotion_Rebate",
            "Promotion Filter",
            "Promotion_Rebate_C_Filter",
            false,
            [
                {
                    customVariableKey: `Promotion_Rebate_C_Filter_GameCategory`,
                    customVariableValue: `${selectedCategory}`,
                },
            ]
        );
    }

    setTlcGameIframeHeight = () => {
        if (document.getElementById("tlc_game_ifame")) {
            //可能已經load完畢，需要檢查document.readyState狀態
            let iframeObj = document.getElementById("tlc_game_ifame");
            let iframeDoc =
                iframeObj.contentDocument || iframeObj.contentWindow
                    ? iframeObj.contentWindow.document
                    : null;
            if (iframeDoc && iframeDoc.readyState == "complete") {
                this.setIframeHeight(iframeObj);
            } else {
                //還沒load完畢 => 等待onload
                iframeObj.onload = () => {
                    this.setIframeHeight(iframeObj);
                };
            }
        } else {
            //最多重試50次(10秒)
            this.setTlcGameIframeHeightCount =
                this.setTlcGameIframeHeightCount + 1;
            if (this.setTlcGameIframeHeightCount <= 50) {
                setTimeout(this.setTlcGameIframeHeight, 200);
            }
        }
    };

    openmodal(selectedItem) {
        let rebateData = [];
        const results = selectedItem.datas;
        for (let i = 0; i < results.length; i++) {
            const resultItem = results[i];
            rebateData.push({
                key: i + 1,
                turnover: resultItem.totalBetAmount,
                rebate: `฿${resultItem.totalGivenAmount}`,
                rebateId: resultItem.rebateId,
                date: moment(resultItem.applyDate).format("DD/MM/YYYY"),
            });
        }
        this.setState({
            visible: true,
            sameRebateItems: rebateData,
            openModalDetail: selectedItem,
        });
    }

    changeRadio(e) {
        this.setState({ isLoading: true });
        Pushgtagdata(
            "Promotion_Rebate",
            "Expand Period",
            "Promotion_Rebate_C_FilterPeriod",
            false,
            [
                {
                    customVariableKey: `Promotion_Rebate_C_FilterPeriod`,
                    customVariableValue: `${
                        e.target.value !== "0"
                            ? e.target.value
                            : "Customization"
                    }`,
                },
            ]
        );

        if (e.target.value === "0") {
            return this.setState({
                visibleDateRange: true,
            });
        } else {
            this.setState({
                isSelfDefined: false,
            });
        }

        this.setState(
            {
                pageIndex: 1,
                dateRadio: e.target.value,
                definedDate: {
                    startTime: moment()
                        .day(moment().day() - (parseInt(e.target.value) - 1))
                        .format("YYYY-MM-DD"),
                    endTime: moment().format("YYYY-MM-DD"),
                },
            },
            () => {
                this.props.setRebateData(
                    this.state.definedDate.startTime,
                    this.state.definedDate.endTime,
                    this.state.SelectedCategory,
                    () => {
                        this.setState({ isLoading: false });
                    }
                );
            }
        );
    }

    /**
     * @description: 返水总计分类列表页
     * @param {*} data  返水数据
     * @return {*}
     */
    RebateData(data, categories) {
        // console.log("返水数据--------------------->", data);
        const { pageIndex, pageSize } = this.state;
        if (!categories) return null;

        let aggregatedData = [];

        categories.forEach((category) => {
            let filterData = data?.filter((element) => {
                return element.promotionCategory == category.PromoCatCode;
            });
            if (filterData && filterData.length > 0) {
                aggregatedData.push({
                    ...category,
                    datas: [...filterData],
                    totalGivenAmount: filterData.reduce(
                        (acc, currentItem) =>
                            acc + currentItem.totalGivenAmount,
                        0
                    ),
                    totalBetAmount: filterData.reduce(
                        (acc, currentItem) => acc + currentItem.totalBetAmount,
                        0
                    ),
                });
            }
        });

        return (
            <React.Fragment>
                {aggregatedData &&
                    aggregatedData
                        .slice((pageIndex - 1) * pageSize, pageIndex * pageSize)
                        .map((item) => (
                            <li
                                className="rebate-item-box"
                                key={"pms-data-" + item.PromoCatCode}
                            >
                                <div className="header-box">
                                    <div className="profile">
                                        <div className="text-box">
                                            <img
                                                className="icon-image"
                                                src={item.promoCatImageUrl}
                                            />
                                            <div>
                                                <h3>{item.resourcesName}</h3>
                                                {/* <p style={{marginTop:"5px"}}>
                                                    {item.rebateGroupName === "Normal"
                                                        ? "会员等级：普通会员"
                                                        : "会员等级：会员"}
                                                </p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => {
                                            this.openmodal(item);
                                        }}
                                    >
                                        <Icon type="right" />
                                    </button>
                                </div>
                                <div className="rebate-info-box">
                                    <div className="content_item">
                                        <p className="title">ยอดหมุนเวียน</p>
                                        {/* 总达流水 */}
                                        <p> {item.totalBetAmount}</p>
                                    </div>
                                    <div className="content_item">
                                        <p className="title">ยอดเงินคืน</p>
                                        {/* 总得返水 */}
                                        <p className="total-amount">
                                            ฿ {item.totalGivenAmount}
                                        </p>
                                    </div>

                                    <div />
                                </div>
                            </li>
                        ))}
            </React.Fragment>
        );
    }

    render() {
        const {
            filterdata,
            PromotionsContent,
            PromotionCategories,
            Tabkey,
            RebateList,
            SelectedCategory,
            rebateDetailTitle,
            rebateDetailSource,
            definedDate,
            isSelfDefined,
            pageIndex,
            isLoading,
            sameRebateItems,
            openModalDetail,
            pageSize,
        } = this.state;
        return (
            <div className="rebate-container">
                {/* {(!this.props.rebateData || !RebateList.length) && (
                    <ul className="loading_card_list">
                        {[...Array(9)].map((item, index) => {
                            return (
                                <li key={index}>
                                    <div className="box">
                                        <div className="box_title" />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )} */}
                <Spin
                    size="large"
                    tip="กำลังโหลด กรุณารอสักครู่..." //加载中，请稍后...
                    style={{ zIndex: "9999999999" }}
                    spinning={!this.props.rebateData || !RebateList.length}
                >
                    <div className="rebate-content">
                        {this.props.rebateData && RebateList?.length ? (
                            <React.Fragment>
                                <Tabs
                                    className="rebate-leftside-tab"
                                    tabPosition={"left"}
                                    //   className="tlc-promotions-wrap"

                                    activeKey={Tabkey}
                                    onChange={(e) => this.callback(Number(e))}
                                >
                                    {RebateList.map((item, index) => (
                                        <TabPane
                                            tab={
                                                <div className="icon-list-wrapper">
                                                    <div className={`icon-list ${Tabkey === index.toString() && "icon-list-active"}`}>
                                                        <img
                                                            className={`icon-image icon-image-active`}
                                                            src={item.promoCatImageUrl}
                                                            style={{
                                                                filter: "greyscale(1)",
                                                            }}
                                                        />
                                                        {item.resourcesName}
                                                    </div>
                                                </div>
                                            }
                                            key={index}
                                        >
                                            {/* 每項item (右半邊) */}
                                            <div className="filter-box">
                                                <div className="usercenter-title-brief">
                                                    <p>
                                                        ยอดคืนเงินทั้งหมด：
                                                        {/* 总得返水： */}
                                                        <strong>
                                                            ฿{" "}
                                                            {this.props
                                                                .rebateFilteredTotalAmount
                                                                ? numberformatter(
                                                                      this.props
                                                                          .rebateFilteredTotalAmount,
                                                                      2
                                                                  )
                                                                : "0.00"}
                                                        </strong>
                                                    </p>
                                                </div>

                                                <Radio.Group
                                                    buttonStyle="solid"
                                                    className="interval-selector-box"
                                                    value={this.state.dateRadio}
                                                    onChange={this.changeRadio}
                                                >
                                                    <Radio.Button value="1">
                                                        วันนี้
                                                        {/* 今天 */}
                                                    </Radio.Button>
                                                    <Radio.Button value="7">
                                                        7 วันล่าสุด
                                                        {/* 近7天 */}
                                                    </Radio.Button>
                                                    <Radio.Button value="30">
                                                        30 วันล่าสุด
                                                        {/* 近30天 */}
                                                    </Radio.Button>
                                                    <Radio.Button value="0">
                                                        กำหนดเอง
                                                        {/* 自定义 */}
                                                    </Radio.Button>
                                                </Radio.Group>
                                            </div>

                                            <div className="Pms_data_rebate">
                                                {isSelfDefined && (
                                                    <p className="defined-date-description">
                                                        {`ตั้งแต่ ${moment(
                                                            definedDate.startTime
                                                        ).format(
                                                            "DD/MM/YYYY"
                                                        )} ถึง ${moment(
                                                            definedDate.endTime
                                                        ).format(
                                                            "DD/MM/YYYY"
                                                        )} `}
                                                        <span
                                                            onClick={() => {
                                                                this.setState({
                                                                    visibleDateRange: true,
                                                                });
                                                            }}
                                                        >
                                                            แก้ไข
                                                            {/* 更改 */}
                                                        </span>
                                                    </p>
                                                )}
                                                <Spin spinning={isLoading}>
                                                    <ul
                                                        className="rebate-list"
                                                        style={{
                                                            marginTop: `${
                                                                isSelfDefined
                                                                    ? "unset"
                                                                    : "30px"
                                                            }`,
                                                        }}
                                                    >
                                                        {!isLoading &&
                                                            filterdata &&
                                                            this.RebateData(
                                                                filterdata,
                                                                PromotionCategories
                                                            )}
                                                        {!filterdata?.length &&
                                                            !isLoading && (
                                                                <Empty
                                                                    description={
                                                                        <p>
                                                                            ไม่พบข้อมูล
                                                                            เดิมพันตอนนี้!
                                                                        </p>
                                                                        // 暂无记录
                                                                    }
                                                                    image={
                                                                        "/th/img/img-no-record.svg"
                                                                    }
                                                                />
                                                            )}
                                                    </ul>
                                                    {filterdata?.length >
                                                        pageSize && (
                                                        <Pagination
                                                            className="general-pagination"
                                                            style={{
                                                                textAlign:
                                                                    "left",
                                                            }}
                                                            defaultCurrent={1}
                                                            pageSize={pageSize}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    pageIndex:
                                                                        e,
                                                                });
                                                            }}
                                                            total={
                                                                this.state
                                                                    .filterdata
                                                                    .length
                                                            }
                                                            hideOnSinglePage={
                                                                true
                                                            }
                                                        />
                                                    )}
                                                </Spin>
                                            </div>
                                        </TabPane>
                                    ))}
                                </Tabs>
                                <DateRange
                                    classNameDatePicker="recordDateRange"
                                    classNameModal="rebate-time-picker-modal"
                                    visible={this.state.visibleDateRange}
                                    dateRangeLimit={90}
                                    closeRange={() => {
                                        this.setState({
                                            visibleDateRange: false,
                                            isLoading: false,
                                        });
                                    }}
                                    setDate={(v) => {
                                        this.setState(
                                            {
                                                pageIndex: 1,
                                                definedDate: v,
                                                dateRadio: "0",
                                                visibleDateRange: false,
                                                isSelfDefined: true,
                                            },
                                            () => {
                                                this.props.setRebateData(
                                                    this.state.definedDate
                                                        .startTime,
                                                    this.state.definedDate
                                                        .endTime,
                                                    this.state.SelectedCategory,
                                                    () => {
                                                        this.setState({
                                                            isLoading: false,
                                                        });
                                                    }
                                                );
                                            }
                                        );
                                    }}
                                />
                            </React.Fragment>
                        ) : null}
                    </div>
                </Spin>

                <Modal
                    className="theme-modal promotion-modal"
                    title={openModalDetail.resourcesName}
                    centered={true}
                    footer={false}
                    visible={this.state.visible}
                    width={800}
                    onCancel={() => {
                        this.setState({
                            visible: false,
                        });
                    }}
                    destroyOnClose={true}
                >
                    <Table
                        className="table-rebate-detail"
                        columns={rebateDetailTitle}
                        dataSource={sameRebateItems}
                        pagination={{ pageSize: 6, hideOnSinglePage: true }}
                    />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        rebateData: state.promotion.rebateData,
        rebateFilteredTotalAmount: state.promotion.rebateFilteredTotalAmount,
        topTabIndex: state.promotion.topTabIndex,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setRebateData: (startTime, endTime, selectedCategory, stopLoading) => {
            dispatch(
                getRebateListAction(
                    startTime,
                    endTime,
                    selectedCategory,
                    stopLoading
                )
            );
        },
        setRebateFilterTotalAmount: (result) => {
            dispatch(promotionActions.setRebateFilterTotalAmount(result));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
